export default __webpack_public_path__ + "images/e8a193346102095c1a675a2ad068045b.svg";